import { useState, useEffect } from "react";
import axios from "axios";
import Card from "../shared/card";
const URL = process.env.REACT_APP_API_URL;
const STATIC_URL = process.env.REACT_APP_STATIC_URL;

const About = () => {
  const [posts, setPosts] = useState([]);
  const imgSrc = STATIC_URL + "/about-bg.jpg";
  const axiosPath = `/posts?section=about`; // `/posts/columns/about`;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(URL + axiosPath);
        setPosts(res.data);
      } catch (err) {
        console.log("get Posts error", err);
      }
    };
    fetchData();
  }, [axiosPath]);

  return (
    <Card
      id="about"
      posts={posts}
    />
  );
};

export default About;
